"use client";

import { LicenseManager } from "ag-grid-enterprise";

/**
 * Initialize AG Grid Enterprise License
 * Uses the same license key as SCS.WEB
 */
export function initializeAgGridLicense() {
  const licenseKey = process.env.NEXT_PUBLIC_AG_GRID_LICENSE_KEY ||
    "Using_this_{AG_Grid}_Enterprise_key_{AG-070821}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Cyber_Finance}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{ScsMgt}_only_for_{1}_Front-End_JavaScript_developer___All_Front-End_JavaScript_developers_working_on_{ScsMgt}_need_to_be_licensed___{ScsMgt}_has_not_been_granted_a_Deployment_License_Add-on___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{5_November_2025}____[v3]_[01]_MTc2MjMwMDgwMDAwMA==4c1c2a5bd47b5908015cfeb2054a2fd9";

  LicenseManager.setLicenseKey(licenseKey);
}

/**
 * AG Grid License Component
 * Can be used as a component to initialize license on mount
 */
export default function AgGridLicense() {
  // Initialize license on module load (client-side only)
  if (typeof window !== "undefined") {
    initializeAgGridLicense();
  }
  return null;
}
